import { createIcon, Svg } from "@gluestack-ui/icon";
import { Path } from "react-native-svg";

const CupIcon = createIcon({
  Root: Svg,
  viewBox: "0 0 28 36",
  path: (
    <>
      <Path
        d="M5.9623 35.0263C4.9551 35.0263 4.11392 34.2586 4.0221 33.2556L1.26152 3.10054C1.15703 1.95915 2.05556 0.974609 3.20172 0.974609H24.0568C25.2078 0.974609 26.1079 1.96711 25.9958 3.11264L23.0455 33.2677C22.9479 34.2655 22.109 35.0263 21.1064 35.0263H5.9623Z"
        stroke="#AEBFFC"
        strokeWidth="2"
        strokeMiterlimit="10"
      />
      <Path
        d="M2.11377 14.8307C3.75523 12.7947 8.46528 12.2589 14.3735 15.7123C20.2818 19.1657 25.2354 14.782 25.2354 14.782"
        stroke="#AEBFFC"
        strokeWidth="2"
        strokeMiterlimit="10"
      />
    </>
  ),
});

export { CupIcon };
